import CadastroInterceptor from '@finx/web-repository/src/apis/Cadastro/CadastroInterceptor'
import FactoryResponse from '@/factories/FactoryResponse'
import { CadastroMedico, DataTablePagination, EnvioConvite, UsuarioCadastro } from '@/types/_'

const factory = new FactoryResponse()
const api = new CadastroInterceptor()

export default {
  async sendCadastroMedico(cadastroMedico: CadastroMedico) {
    const { conviteId } = cadastroMedico
    const request = await api.postAllowAnonymous(`convite-usuarios/${conviteId}/cadastrar-usuario`, cadastroMedico)
    return factory.build(request)
  },

  async deletePessoa(id: string) {
    const request = await api.delete(`pessoas/${id}`)
    return factory.build(request)
  },

  async sendConvite(convite: EnvioConvite) {
    const request = await api.post('convite-usuarios', convite)
    return factory.build(request)
  },

  async deletarConvite(conviteId: string) {
    const request = await api.delete(`convite-usuarios/${conviteId}`)
    return factory.build(request)
  },

  async resendConvite(conviteId: string) {
    const request = await api.post(`convite-usuarios/${conviteId}/reenviar`, conviteId)
    return factory.build(request)
  },

  async getConvitesAll(hospitais: string[]) {
    const params = `hospitais=${hospitais.join('&hospitais=')}`
    const request = await api.get(`convite-usuarios?${params}`)
    return factory.build(request)
  },

  async getConviteUsuario(params: any) {
    const request = await api.getAllowAnonymous(`convite-usuarios/${params.conviteId}/tipo-convite/${params.tipoConvite}`)
    return factory.build(request)
  },

  async generateQrCode(conviteId: string) {
    const request = await api.getAllowAnonymous(`convite-usuarios/${conviteId}/qr-assinatura-medico`)
    return factory.build(request)
  },

  async uploadAssinatura(upload: any) {
    const request = await api.postAllowAnonymous(`convite-usuarios/${upload.conviteId}/assinatura`, upload)
    return factory.build(request)
  },

  async getCbosAll() {
    const request = await api.getAllowAnonymous('cbos')
    return factory.build(request)
  },

  async checkExists(cpf: string) {
    const request = await api.getAllowAnonymous(`pessoas/check-cpf-exists/${cpf}`)
    return factory.build(request)
  },

  async validaCpfExists(cpf: string) {
    const request = await api.getAllowAnonymous(`pessoas/check-cpf-exists/${cpf}`)
    return factory.build(request)
  },

  async checkExisteContaCadastrada(cpf: string) {
    const request = await api.getAllowAnonymous(`usuario/check-existe-conta-cadastrada?cpf=${cpf}`)
    return factory.build(request)
  },

  async checkExisteContaCadastradaPorEmail(email: string) {
    const request = await api.getAllowAnonymous(`usuario/any/${email}`)
    return factory.build(request)
  },

  async pessoaUpsert(usuario: UsuarioCadastro) {
    const request = await api.put('pessoas/upsert', usuario)
    return factory.build(request)
  },

  async getPessoalAll(dataTableItens: any) {
    const { page, rowsPerPage, searchText } = dataTableItens

    let query = ''

    if (page) {
      query += `&page=${page}`
    }

    if (rowsPerPage) {
      query += `&totalPages=${rowsPerPage}`
    }

    if (searchText) {
      query += `&searchText=${searchText}`
    }

    query = query.substring(1, query.length)
    const request = await api.get(`pessoas?${query}`)
    return factory.build(request)
  },

  async getPessoalById(id: string) {
    const request = await api.get(`pessoas/info/${id}`)
    return factory.build(request)
  },

  async getPowerBiReportTypes() {
    const response = await api.get('usuarios/current/relatorios')
    return factory.build(response)
  },

  async checkCpfRemuneracao(cpf: string) {
    const request = await api.get(`pessoas/${cpf}?comUsuario=false`)
    return factory.build(request)
  },

  async upsertPessoaRemuneracao(pessoa: any) {
    const request = await api.put('pessoas/upsert', pessoa)
    return factory.build(request)
  },

  async getPowerBiEmbeddedInfo(reportId: string, hospitalId?: string) {
    let requestURL: string = `relatorios/${reportId}/power-bi-embedded`

    if (hospitalId) {
      const queryParams: string = new URLSearchParams({ hospitalId }).toString()
      requestURL = `${requestURL}?${queryParams}`
    }

    const request = await api.get(requestURL)
    return factory.build(request)
  },

  async importListaDeSecretariasCsv(hospitalId: string, data: any) { // cargaConviteMedicoUseCaseModel
    const request = await api.upload(`carga-convite-medico/${hospitalId}`, data, { 'Content-Type': 'multipart/form-data' })
    return factory.build(request)
  },
}
